'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useContext } from 'react';
import Loading from './loading';
import { WaitForLoad } from '@components/spinner/Spinner';
import { Traceability } from '../_components/traceability';
import { useQueryOrg } from '@services/useQueryOrg';
import { RootStoreContext } from '@stores/rootStore';
import { interpolateColors } from '@services/utils';
import { useSearchParams } from 'next/navigation';
import { SankeyResponse, StatResponse } from '@services/responseTypes';
export default function Page() {
  const $ = _c(83);
  const {
    uiStore
  } = useContext(RootStoreContext);
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams?.has("filter[year]") || searchParams?.has("filter[season_id]");
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const hasYearOrSeason = t0;
  let t1;
  if ($[2] !== searchParams) {
    t1 = searchParams?.get("filter[season_id]");
    $[2] = searchParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== searchParams) {
    t2 = searchParams?.get("filter[year]");
    $[4] = searchParams;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== searchParams) {
    t3 = searchParams?.get("filter[crop]");
    $[6] = searchParams;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== searchParams) {
    t4 = searchParams?.get("filter[label_ids][]");
    $[8] = searchParams;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== searchParams) {
    t5 = searchParams?.get("filter[country]");
    $[10] = searchParams;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== searchParams) {
    t6 = searchParams?.get("filter[province]");
    $[12] = searchParams;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== searchParams) {
    t7 = searchParams?.get("filter[village]");
    $[14] = searchParams;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== searchParams) {
    t8 = searchParams?.get("filter[subdistrict]");
    $[16] = searchParams;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== searchParams) {
    t9 = searchParams?.get("filter[district]");
    $[18] = searchParams;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t1 || $[21] !== t2 || $[22] !== t3 || $[23] !== t4 || $[24] !== t5 || $[25] !== t6 || $[26] !== t7 || $[27] !== t8 || $[28] !== t9) {
    t10 = ["overview", "sankey", t1, t2, t3, t4, t5, t6, t7, t8, t9];
    $[20] = t1;
    $[21] = t2;
    $[22] = t3;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== searchParams || $[31] !== uiStore) {
    t11 = () => uiStore.currentOrganization?.fetchSankeyData({
      ...(searchParams?.has("filter[season_id]") && {
        season: searchParams?.get("filter[season_id]") || undefined
      }),
      ...(searchParams?.has("filter[year]") && {
        year: parseInt(searchParams.get("filter[year]"), 10)
      }),
      ...(searchParams?.has("filter[crop]") && {
        crop: searchParams.get("filter[crop]") || undefined
      }),
      ...(searchParams?.has("filter[label_ids][]") && {
        labels: searchParams.get("filter[label_ids][]") || undefined
      }),
      ...(searchParams?.has("filter[country]") && {
        country: searchParams.get("filter[country]") || undefined
      }),
      ...(searchParams?.has("filter[province]") && {
        region: searchParams.get("filter[province]") || undefined
      }),
      ...(searchParams?.has("filter[village]") && {
        village: searchParams.get("filter[village]") || undefined
      }),
      ...(searchParams?.has("filter[subdistrict]") && {
        subdistrict: searchParams.get("filter[subdistrict]") || undefined
      }),
      ...(searchParams?.has("filter[district]") && {
        district: searchParams.get("filter[district]") || undefined
      })
    });
    $[30] = searchParams;
    $[31] = uiStore;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== hasYearOrSeason || $[34] !== t10 || $[35] !== t11) {
    t12 = {
      queryKey: t10,
      queryFn: t11,
      enabled: hasYearOrSeason,
      refetchOnWindowFocus: false
    };
    $[33] = hasYearOrSeason;
    $[34] = t10;
    $[35] = t11;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  const {
    data: sankey,
    isLoading: isLoadingSankey
  } = useQueryOrg(t12);
  let t13;
  if ($[37] !== searchParams) {
    t13 = searchParams?.get("filter[season_id]");
    $[37] = searchParams;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  let t14;
  if ($[39] !== searchParams) {
    t14 = searchParams?.get("filter[year]");
    $[39] = searchParams;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  let t15;
  if ($[41] !== searchParams) {
    t15 = searchParams?.get("filter[crop]");
    $[41] = searchParams;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  let t16;
  if ($[43] !== searchParams) {
    t16 = searchParams?.get("filter[label_ids][]");
    $[43] = searchParams;
    $[44] = t16;
  } else {
    t16 = $[44];
  }
  let t17;
  if ($[45] !== searchParams) {
    t17 = searchParams?.get("filter[country]");
    $[45] = searchParams;
    $[46] = t17;
  } else {
    t17 = $[46];
  }
  let t18;
  if ($[47] !== searchParams) {
    t18 = searchParams?.get("filter[province]");
    $[47] = searchParams;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  let t19;
  if ($[49] !== searchParams) {
    t19 = searchParams?.get("filter[village]");
    $[49] = searchParams;
    $[50] = t19;
  } else {
    t19 = $[50];
  }
  let t20;
  if ($[51] !== searchParams) {
    t20 = searchParams?.get("filter[district]");
    $[51] = searchParams;
    $[52] = t20;
  } else {
    t20 = $[52];
  }
  let t21;
  if ($[53] !== searchParams) {
    t21 = searchParams?.get("filter[subdistrict]");
    $[53] = searchParams;
    $[54] = t21;
  } else {
    t21 = $[54];
  }
  let t22;
  if ($[55] !== t13 || $[56] !== t14 || $[57] !== t15 || $[58] !== t16 || $[59] !== t17 || $[60] !== t18 || $[61] !== t19 || $[62] !== t20 || $[63] !== t21) {
    t22 = ["overview", "charts", t13, t14, t15, t16, t17, t18, t19, t20, t21];
    $[55] = t13;
    $[56] = t14;
    $[57] = t15;
    $[58] = t16;
    $[59] = t17;
    $[60] = t18;
    $[61] = t19;
    $[62] = t20;
    $[63] = t21;
    $[64] = t22;
  } else {
    t22 = $[64];
  }
  let t23;
  if ($[65] !== searchParams || $[66] !== uiStore) {
    t23 = () => uiStore.currentOrganization?.fetchTraceabilityChartData({
      ...(searchParams?.has("filter[season_id]") && {
        season: searchParams?.get("filter[season_id]") || undefined
      }),
      ...(searchParams?.has("filter[year]") && {
        year: parseInt(searchParams.get("filter[year]"), 10)
      }),
      ...(searchParams?.has("filter[crop]") && {
        crop: searchParams.get("filter[crop]") || undefined
      }),
      ...(searchParams?.has("filter[label_ids][]") && {
        labels: searchParams.get("filter[label_ids][]") || undefined
      }),
      ...(searchParams?.has("filter[country]") && {
        country: searchParams.get("filter[country]") || undefined
      }),
      ...(searchParams?.has("filter[province]") && {
        region: searchParams.get("filter[province]") || undefined
      }),
      ...(searchParams?.has("filter[village]") && {
        village: searchParams.get("filter[village]") || undefined
      }),
      ...(searchParams?.has("filter[subdistrict]") && {
        subdistrict: searchParams.get("filter[subdistrict]") || undefined
      }),
      ...(searchParams?.has("filter[district]") && {
        district: searchParams.get("filter[district]") || undefined
      })
    });
    $[65] = searchParams;
    $[66] = uiStore;
    $[67] = t23;
  } else {
    t23 = $[67];
  }
  let t24;
  if ($[68] !== hasYearOrSeason || $[69] !== t22 || $[70] !== t23) {
    t24 = {
      queryKey: t22,
      queryFn: t23,
      enabled: hasYearOrSeason,
      refetchOnWindowFocus: false
    };
    $[68] = hasYearOrSeason;
    $[69] = t22;
    $[70] = t23;
    $[71] = t24;
  } else {
    t24 = $[71];
  }
  const {
    data: charts,
    isLoading: isLoadingTxes
  } = useQueryOrg(t24);
  let t25;
  if ($[72] !== sankey?.nodes) {
    t25 = interpolateColors(sankey?.nodes) || {};
    $[72] = sankey?.nodes;
    $[73] = t25;
  } else {
    t25 = $[73];
  }
  const legendColors = t25;
  const t26 = isLoadingSankey || isLoadingTxes;
  let t27;
  if ($[74] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <Loading />;
    $[74] = t27;
  } else {
    t27 = $[74];
  }
  let t28;
  if ($[75] !== charts || $[76] !== legendColors || $[77] !== sankey || $[78] !== searchParams) {
    t28 = () => <Traceability charts={charts} sankeyData={sankey} legendColors={legendColors} crop={searchParams?.get("filter[crop]") || null} />;
    $[75] = charts;
    $[76] = legendColors;
    $[77] = sankey;
    $[78] = searchParams;
    $[79] = t28;
  } else {
    t28 = $[79];
  }
  let t29;
  if ($[80] !== t26 || $[81] !== t28) {
    t29 = <WaitForLoad isLoading={t26} customSpinner={t27}>{t28}</WaitForLoad>;
    $[80] = t26;
    $[81] = t28;
    $[82] = t29;
  } else {
    t29 = $[82];
  }
  return t29;
}